import React from 'react';
import Reservation from '../../frontend-common-libs/src/fleet-management/Reservation';
import { ReservationProtocol } from '../../frontend-common-libs/src/fleet-management/types';
import Job from '../../frontend-common-libs/src/fleet-management/Job';
import noneProtocolItem from '../../frontend-common-libs/src/fleet-management/noneProtocolItem';

export function setEditReservationsMode(
  setEditReservations: React.Dispatch<React.SetStateAction<boolean>>,
  inEditReservationMode: boolean
) {
  setEditReservations(inEditReservationMode);
}

function filterSelectedReservationProtocolArray(
  reservationProtocolArray: ReservationProtocol[],
  selectedInstruments: string[]
): ReservationProtocol[] {
  return reservationProtocolArray.filter(item => selectedInstruments.includes(item.instrumentId));
}

export default async function unreserveSelectedInstruments(
  selectedInstruments: string[],
  clearSelection: () => void,
  reservationProtocol: string
): Promise<void> {
  if (selectedInstruments.length > 0) {
    await Reservation.bulkUnreserve(selectedInstruments);
    const selectedReservationProtocolArray = filterSelectedReservationProtocolArray(
      JSON.parse(reservationProtocol),
      selectedInstruments
    );
    await Job.bulkDeleteJob(selectedReservationProtocolArray);
    clearSelection();
  }
}

function updateReservationProtocolsToNone(
  reservationProtocolArray: ReservationProtocol[]
): ReservationProtocol[] {
  return reservationProtocolArray.map(item => ({
    ...item,
    jobId: '',
    protocolName: noneProtocolItem.name
  }));
}

function updatePreviousReservationProtocolArray(
  reservationProtocolArray: ReservationProtocol[],
  updatedSelectedReservationProtocolArray: ReservationProtocol[]
): ReservationProtocol[] {
  return reservationProtocolArray.map(
    existingItem =>
      updatedSelectedReservationProtocolArray.find(
        updatedItem => updatedItem.instrumentId === existingItem.instrumentId
      ) || existingItem
  );
}

async function assignNoneProtocol(
  reservationProtocolArray: ReservationProtocol[],
  selectedInstruments: string[]
): Promise<ReservationProtocol[]> {
  const selectedReservationProtocolArray = filterSelectedReservationProtocolArray(
    reservationProtocolArray,
    selectedInstruments
  );

  await Job.bulkDeleteJob(selectedReservationProtocolArray);
  const updatedSelectedReservationProtocolArray = updateReservationProtocolsToNone(
    selectedReservationProtocolArray
  );
  return updatePreviousReservationProtocolArray(
    reservationProtocolArray,
    updatedSelectedReservationProtocolArray
  );
}

function createReservationProtocolIfNotExists(
  selectedInstruments: string[],
  reservationProtocolArray: ReservationProtocol[],
  selectedProtocolName: string
): ReservationProtocol[] {
  let reservationObjectIndex: number;
  const updatedReservationProtocolArray = reservationProtocolArray;

  selectedInstruments.forEach(instrumentId => {
    reservationObjectIndex = updatedReservationProtocolArray.findIndex(
      item => item.instrumentId === instrumentId
    );
    if (reservationObjectIndex !== -1) {
      updatedReservationProtocolArray[reservationObjectIndex].protocolName = selectedProtocolName;
    } else {
      updatedReservationProtocolArray.push({
        instrumentId,
        jobId: '',
        protocolName: selectedProtocolName
      });
    }
  });
  return updatedReservationProtocolArray;
}

async function assignProtocolCreateJob(
  reservationProtocolArray: ReservationProtocol[],
  selectedInstruments: string[],
  selectedProtocolId: string,
  selectedProtocolName: string
): Promise<ReservationProtocol[]> {
  let selectedReservationProtocolArray = filterSelectedReservationProtocolArray(
    reservationProtocolArray,
    selectedInstruments
  );

  selectedReservationProtocolArray = createReservationProtocolIfNotExists(
    selectedInstruments,
    selectedReservationProtocolArray,
    selectedProtocolName
  );

  return Job.bulkCreateWithProtocol(selectedReservationProtocolArray, selectedProtocolId);
}

export async function assignProtocolHandler(
  selectedProtocolName: string,
  selectedInstruments: string[],
  reservationProtocolPrev: string,
  setReservationProtocol: React.Dispatch<React.SetStateAction<string>>,
  selectedProtocolId: string
): Promise<void> {
  const reservationProtocolArray = JSON.parse(reservationProtocolPrev) as ReservationProtocol[];
  let updatedReservationProtocolArray: ReservationProtocol[] = [];

  if (selectedProtocolId === noneProtocolItem.id) {
    updatedReservationProtocolArray = await assignNoneProtocol(
      reservationProtocolArray,
      selectedInstruments
    );
  } else {
    updatedReservationProtocolArray = await assignProtocolCreateJob(
      reservationProtocolArray,
      selectedInstruments,
      selectedProtocolId,
      selectedProtocolName
    );
  }

  setReservationProtocol(JSON.stringify(updatedReservationProtocolArray));
}

export function removeInstrumentAssignedProtocol(
  reservationProtocol: string,
  selectedInstruments: string[]
): string {
  const reservationProtocolArray = JSON.parse(reservationProtocol) as ReservationProtocol[];
  const updatedReservationProtocolArray = reservationProtocolArray.filter(
    instrument => selectedInstruments.indexOf(instrument.instrumentId) === -1
  );

  return JSON.stringify(updatedReservationProtocolArray);
}
